<script lang="ts">
  import {
    t,
    locales,
  } from "$lib/i18n/translations";
  import locale,{ setLanguage, type language } from "$lib/i18n/locale";
  import { hapticConfirm, hapticSwitch } from "$lib/haptics";
  import { base } from "$app/paths";
  import { goto } from "$app/navigation";
  import { page } from "$app/stores";
  import { onDestroy, onMount } from "svelte";
  import Logo from "../icons/Logo.svelte"

  // 获取所有语言
  const dropdownItems = () => {
    return $locales.reduce((obj, lang) => {
      return {
        ...obj,
        [lang]: $t(`languages.${lang}`),
      };
    }, {});
  };
  const items = dropdownItems() as Record<string, string>;
  // 当前选择的语言
  $: selectedOption = $locale;

  // 下拉菜单状态
  let isDropdownOpen = false;

  // 切换下拉菜单状态
  const toggleDropdown = () => {
    hapticSwitch();
    isDropdownOpen = !isDropdownOpen;
  };

  // 关闭下拉菜单
  const closeDropdown = () => {
    isDropdownOpen = false;
  };
  $: isDark = ["/about", "/privacyPolicy"].some((path) =>
    $page.url.pathname.includes(path)
  );
  // 语言切换处理函数
  const changeLanguage = (langCode: language) => {
    if (langCode === selectedOption) {
      closeDropdown();
      return;
    }
    setLanguage(langCode)

    hapticConfirm();

    // 获取当前路径
    const currentPath = $page.url.pathname;

    // 提取当前路径中的语言代码后面的部分
    const pathParts = currentPath.split("/");

    // 如果路径至少有3部分（例如 /en/video），则保留语言后面的部分
    let newPath;
    if (pathParts.length >= 3) {
      // 移除空字符串和语言代码，然后重新组合
      const pathWithoutLang = pathParts.slice(2).join("/");
      newPath = `${base}/${String(langCode)}/${pathWithoutLang}`;
    } else {
      const lastPart = pathParts[pathParts.length - 1];
      if(items[lastPart]){
        newPath = `${base}/${String(langCode)}`;
      }else{
        newPath = `${base}/${String(langCode)}/${lastPart}`;
      }
    }

    goto(newPath, {
      replaceState: true,
    });

    closeDropdown();
  };

  // 获取所有语言代码
  const langCodes = Object.keys(items) as language[];

  // 点击外部区域关闭下拉菜单
  let dropdownRef: HTMLDivElement;

  function handleClickOutside(event: MouseEvent) {
    if (
      isDropdownOpen &&
      dropdownRef &&
      !dropdownRef.contains(event.target as Node)
    ) {
      closeDropdown();
    }
  }
  onMount(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
</script>

<nav class="flex flex-rows justify-between h-[72px] w-full items-center px-[16px] max-mobile:h-[56px] max-mobile:bg-white">
  <div
    class="flex justify-center items-center cursor-pointer"
  >
    <div class="size-[40px] max-mobile:size-[32px]">
      <svelte:component this={Logo} />
    </div>
    <a
      class="text-[20px] ml-[8px] font-bold max-mobile:text-[#F84095] max-mobile:text-[16px] {isDark
        ? '!text-[#F84095]'
        : '!text-white'}"
      href="/{selectedOption}"
      target="_self"
    >
      {$t("general.cobalt")}
  </a>
  </div>

  <!-- 语言选择器 -->
  <div class="relative" bind:this={dropdownRef}>
    <!-- 当前选择的语言 -->
    <div
      on:click|stopPropagation={toggleDropdown}
      class="flex items-center text-[18px] cursor-pointer max-mobile:text-black max-mobile:text-[16px] {isDark
        ? 'text-black'
        : 'text-white'}"
      aria-hidden="true"
    >
      {items[selectedOption]}
      <svg
        class="ml-1 w-4 h-4 transition-transform {isDropdownOpen
          ? 'rotate-180'
          : ''}"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </div>

    <!-- 下拉菜单 -->
    {#if isDropdownOpen}
      <div
        class="absolute right-0 mt-2 w-[484px] bg-white rounded-lg shadow-lg z-50  max-mobile:w-[220px]"
        style="transform-origin: top right;"
      >
        <div class="grid grid-cols-3 gap-6 p-6 text-[14px] leading-normal max-mobile:grid-cols-2"> 
          {#each langCodes as langCode}
            <div
              on:click|stopPropagation={() => changeLanguage(langCode)}
              class="text-left hover:text-[#F84095] transition-colors cursor-pointer {selectedOption ===
              langCode
                ? 'text-[#F84095] font-medium'
                : 'text-black'}"
              aria-hidden="true"
            >
              {items[langCode]}
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</nav>
